import {
  Directive,
  Input,
  HostListener,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { TrackingService } from '../../services/app-track/tracking.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { AuthService } from '../../services/security/auth.service';

@Directive({
  selector: '[appTrackClick]',
  exportAs: 'appTrackClick', // 👈 Permite referenciar la directiva en el template
})
export class AppTrackDirective implements OnInit {
  @Input() trackData!: TrackData;
  @Input() debounceTime = 500; // 👈 Tiempo configurable
  @Input() disabled = false; // 👈 Propiedad para deshabilitar

  @Output() trackedClick = new EventEmitter<Event>(); // 👈 dispara el evento real

  private logInfo: any;
  private cedulaAsesor: string = '';
  private nombreAsesor: string = '';
  private lastClickTime = 0;
  private isProcessing = false;

  constructor(
    private trackingService: TrackingService,
    private authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();

    if (this.logInfo) {
      const userCC = this.logInfo?.document ?? '';
      this.cedulaAsesor = userCC.includes('.')
        ? userCC.split('.')[1].trim()
        : userCC;

      this.nombreAsesor = `${this.logInfo.nombre ?? ''} ${
        this.logInfo.primerApellido ?? ''
      } ${this.logInfo.segundoApellido ?? ''}`.trim();
    } else {
      this.cedulaAsesor = 'N/A';
      this.nombreAsesor = 'N/A';
    }
  }

  @HostListener('click', ['$event'])
  async onClick(event: Event) {
    if (this.disabled || this.isProcessing) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    const now = Date.now();
    if (now - this.lastClickTime < this.debounceTime) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    this.lastClickTime = now;
    this.isProcessing = true;

    try {
      await this.trackEvent();
      this.trackedClick.emit(event); // 👈 ejecuta la acción del botón
    } catch (error) {
      console.error('Error en tracking:', error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, this.debounceTime);
    }
  }

  private async trackEvent(): Promise<void> {
    if (!this.trackData) {
      console.warn('appTrackClick: No se ha definido trackData');
      return;
    }

    const payload: TrackData = {
      ...this.trackData,
      cedulaAsesor: this.cedulaAsesor,
      nombreAsesor: this.nombreAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
    };

    this.trackingService.trackEvent(payload).subscribe({
      next: () => console.log(`Tracking registrado: ${payload.functionality}`),
      error: (error) => console.warn('Error registrando tracking', error),
    });
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
